var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCancel = function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m4.917 11.795 3-3 3 3 .878-.878-3-3 3-3-.878-.878-3 3-3-3-.878.878 3 3-3 3zm3.001 4.038a7.7 7.7 0 0 1-3.088-.623 8 8 0 0 1-2.514-1.692 8 8 0 0 1-1.692-2.513A7.7 7.7 0 0 1 0 7.918Q0 6.276.623 4.83a8 8 0 0 1 1.692-2.514A8 8 0 0 1 4.828.624 7.7 7.7 0 0 1 7.915 0q1.642 0 3.088.623 1.445.624 2.514 1.692a8 8 0 0 1 1.693 2.513q.623 1.444.623 3.087a7.7 7.7 0 0 1-.623 3.088 8 8 0 0 1-1.692 2.514 8 8 0 0 1-2.513 1.693 7.7 7.7 0 0 1-3.087.623"
  })));
};
export default SvgCancel;